import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchMenu = () => axios.get(`${API}/menu`).then((r) => r.data.items);
export const fetchSchedule = () => axios.get(`${API}/schedule`).then((r) => r.data.stops);
export const fetchReviews = () => axios.get(`${API}/reviews`).then((r) => r.data.reviews);
export const submitBooking = (payload) => axios.post(`${API}/bookings`, payload).then((r) => r.data);

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("cb_admin_token") || ""}` },
});
export const adminLogin = (email, password) => axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const adminMe = () => axios.get(`${API}/auth/me`, authHeader()).then((r) => r.data);
export const adminSaveSchedule = (stops) => axios.put(`${API}/admin/schedule`, { stops }, authHeader()).then((r) => r.data);
export const adminSaveMenu = (items) => axios.put(`${API}/admin/menu`, { items }, authHeader()).then((r) => r.data);
export const fetchEvents = () => axios.get(`${API}/events`).then((r) => r.data.events);
export const adminSaveEvents = (events) => axios.put(`${API}/admin/events`, { events }, authHeader()).then((r) => r.data);
export const adminSaveReviews = (reviews) => axios.put(`${API}/admin/reviews`, { reviews }, authHeader()).then((r) => r.data);
